import React, { Component } from "react";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock
} from "react-bootstrap";
import styles from "./Textarea.scss";

class Textarea extends Component {
  render() {
    const {
      input,
      disableCounter,
      placeholder,
      name,
      className,
      minLength,
      maxlength,
      label,
      help,
      rows,
      meta: { error, warning, touched, valid }
    } = this.props;
    const length = input.value.length;

    const validationState =
      (touched && valid && "success") ||
      (touched && error && "error") ||
      (touched && warning && "warning") ||
      null;

    return (
      <FormGroup validationState={validationState}>
        {label && <ControlLabel className={styles.label}>{label}</ControlLabel>}
        <FormControl
          componentClass="textarea"
          placeholder={placeholder}
          value={input.value}
          name={name}
          onChange={input.onChange}
          className={className || styles.textarea}
          minLength={minLength}
          maxLength={maxlength}
          rows={rows || 3}
          onBlur={input.onBlur}
          autoComplete="rnd-str"
        />
        {help && <HelpBlock className={styles.help}>{help}</HelpBlock>}
        {length > 0 &&
          !disableCounter &&
          (minLength ? length >= minLength : true) && (
            <p className={styles.charSign}>
              {maxlength - length} characters left
            </p>
          )}
        {!disableCounter && length < minLength && length > 0 && minLength && (
          <p className={styles.charSignErr}>
            {minLength - length} characters to go
          </p>
        )}
        {length <= 0 && !disableCounter && (
          <p className={styles.help}>
            {minLength ? `${minLength}-` : ""}
            {maxlength} characters {minLength ? "" : "max"}
          </p>
        )}
        {touched && error && <p className={styles.error}>{error}</p>}
      </FormGroup>
    );
  }
}

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/common/textarea/Textarea.js